import { Flower2 } from "lucide-react";
import { useLang } from "@/lib/i18n";

const CONTENT = {
  en: {
    items: [
      "Post-existential",
      "Relational care",
      "A safe space",
      "Individual focus",
      "Unhurried time",
    ],
  },
  el: {
    items: [
      "Μετα-υπαρξιακή",
      "Σχεσιακή φροντίδα",
      "Ασφαλής χώρος",
      "Ατομική προσέγγιση",
      "Χωρίς βιασύνη",
    ],
  },
};

const Marquee = () => {
  const { lang } = useLang();
  const items = CONTENT[lang].items;
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-sage-600/10 bg-secondary/60 py-6"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((group) => (
          <div key={group} aria-hidden={group === 1} className="flex shrink-0 items-center">
            {items.map((item) => (
              <span
                key={`${group}-${item}`}
                className="flex items-center gap-10 px-10 font-display text-2xl italic text-sage-600 md:text-3xl"
              >
                <Flower2 className="h-5 w-5 shrink-0 text-clay" strokeWidth={1.5} />
                {item}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
